import { defaultAxios, IParams } from './base';

export interface IFetchCustTotalProductList extends IParams {
  custSeq?: number;
}

export const fetchCustTotalProductList = (
  params: IFetchCustTotalProductList,
) => {
  return defaultAxios().post(`/cust/v2/total/product/list`, params);
};
